import React, { useState } from "react";
import "./Projects.css";

function Projects({ featuredOnly = false }) {
  const [showAll, setShowAll] = useState(false);

  const projects = [
    {
      category: "OFFSHORE WELL COMPLETION",
      title: "FYIP 5 Oil Wells Completion Works",
      description:
        "Completion works for five oil wells at Cluster 5A in the Forcados Estuary Offshore Oil Field, covering topside fabrication, piping hook-up, structural rehabilitation, pre-commissioning and subsea inspection.",
      image: "/images/cluster 5a.webp",
      location: "Cluster 5A, Forcados Estuary Offshore Oil Field",
      scope:
        "Topside piping, bulkline hook-up, valve conversion, grit blasting and painting, N2 inerting, and riser clamp and flange inspection.",
    },

    {
      category: "MANIFOLD REFURBISHMENT",
      title: "Refurbishment of the Belema Old Inlet Manifold",
      description:
        "Refurbishment works on the Belema Old Inlet Manifold to restore dependable performance and support safe, reliable operations.",
      image: "/images/belema inlet manifold.webp",
      location: "Belema",
      scope:
        "Manifold refurbishment, repair and associated inspection works.",
    },

    {
      category: "OFFSHORE INSTALLATION WORKS",
      title: "Strides Jack-Up Barge (JUB) at Work",
      description:
        "Strides deployed its Jack-Up Barge to support installation works at SPDC offshore estuary wellhead clusters, demonstrating its capability in offshore construction, marine operations and oil and gas installation services.",
      image: "/images/jackup barge.webp",
      location: "SPDC Offshore Estuary Wellhead Clusters",
      scope:
        "Project year: 2017. Project type: Offshore Installation Works. Asset: Jack-Up Barge (JUB).",
    },

    {
      category: "DIVING OPERATIONS",
      title: "Diver Operations in Choppy Water",
      description:
        "Specialized diver operations carried out in choppy water conditions, supporting underwater inspection, maintenance and safe offshore activities.",
      image: "/images/diver in choppy water.webp",
      location: "Offshore and coastal field operations",
      scope: "Diving support, underwater inspection and marine maintenance operations.",
    },
    {
      category: "STORAGE FACILITIES",
      title: "Tank Farm Construction and Rehabilitation",
      description: "Construction and rehabilitation works supporting dependable petroleum storage operations.",
      image: "/images/Tank Farm Construction and Reh Services.webp",
      location: "Petroleum storage facilities",
      scope: "Tank farm construction, rehabilitation, repair and facility improvement works.",
    },
    {
      category: "TANK FARM OPERATIONS",
      title: "Industrial Tank Asset Improvement",
      description: "Asset improvement works that strengthen storage reliability, safety and operational readiness.",
      image: "/images/tank2.webp",
      location: "Industrial tank farm facilities",
      scope: "Tank asset maintenance, improvement works and operational readiness support.",
    },
    {
      category: "ENERGY INFRASTRUCTURE",
      title: "Tank Installation and Maintenance Works",
      description: "Practical installation and maintenance support for critical energy infrastructure.",
      image: "/images/tank image 3.webp",
      location: "Energy and industrial facilities",
      scope: "Tank installation, maintenance, inspection and supporting infrastructure works.",
    },
    {
      category: "MARINE LOGISTICS",
      title: "Vessel Supply and Offshore Support",
      description: "Marine logistics and vessel support that keep offshore activities coordinated and moving.",
      image: "/images/vessel suppy operations.webp",
      location: "Offshore and coastal work sites",
      scope: "Vessel supply, marine logistics, crew coordination and offshore operational support.",
    },
    {
      category: "MARITIME OPERATIONS",
      title: "Coastal and Offshore Marine Operations",
      description: "Coordinated marine operations for complex coastal, offshore and industrial assignments.",
      image: "/images/marine (1).webp",
      location: "Coastal and offshore environments",
      scope: "Marine operations, vessel coordination and logistical support for field assignments.",
    },
    {
      category: "DREDGING OPERATIONS",
      title: "Waterway and Marine Access Works",
      description: "Dredging and marine works that improve access, navigation and project readiness.",
      image: "/images/dredging.webp",
      location: "Coastal waterways and marine access routes",
      scope: "Dredging, waterway preparation, access improvement and marine construction support.",
    },
    {
      category: "SUBSEA SERVICES",
      title: "Subsea Installation and Inspection",
      description: "Subsea installation and inspection support for underwater infrastructure and offshore assets.",
      image: "/images/diving and subsea installation.webp",
      location: "Offshore subsea assets",
      scope: "Subsea installation, inspection, maintenance and underwater asset integrity support.",
    },
    {
      category: "HOOK-UP AND COMMISSIONING",
      title: "Offshore Facility Hook-up Works",
      description: "Hook-up, testing and commissioning support for safe and reliable facility start-up.",
      image: "/images/hookup and comissioning.webp",
      location: "Shallow offshore facilities",
      scope: "Mechanical hook-up, testing, pre-commissioning and facility start-up support.",
    },
    {
      category: "OPERATIONAL EXCELLENCE",
      title: "Integrated Field Delivery",
      description: "Disciplined field execution that brings engineering, marine and operational teams together.",
      image: "/images/operational excellence.webp",
      location: "Energy and maritime project sites",
      scope: "Integrated engineering, marine coordination, field execution and performance assurance.",
    },
    {
      category: "INDUSTRY EXPERTISE",
      title: "Engineering and Asset Support",
      description: "Engineering-led support designed around site realities, asset performance and project outcomes.",
      image: "/images/industry expertise.webp",
      location: "Client energy and industrial assets",
      scope: "Engineering support, asset assessment, maintenance planning and technical delivery.",
    },
    {
      category: "PIPELINE SERVICES",
      title: "Pipeline Repair and Integrity Support",
      description: "Pipeline integrity works that help protect production continuity and long-term asset performance.",
      image: "/images/iprs.webp",
      location: "Oil and gas pipeline networks",
      scope: "Pipeline repair, integrity assessment, rehabilitation and production continuity support.",
    },
    {
      category: "COMMUNITY AND IMPACT",
      title: "Community-Focused Project Delivery",
      description: "Project delivery that recognises local communities and creates lasting operational value.",
      image: "/images/community.webp",
      location: "Project communities and host locations",
      scope: "Community engagement, local participation and responsible project delivery initiatives.",
    },
    {
      category: "SAFETY AND QUALITY",
      title: "Safety-Led Operations",
      description: "Safety and quality systems embedded across project planning, execution and close-out.",
      image: "/images/safetyfirst.webp",
      location: "Project sites and operational facilities",
      scope: "HSE planning, quality control, risk management and safe project execution systems.",
    },
    {
      category: "MARINE ENGINEERING",
      title: "Marine Construction Support",
      description: "Marine construction support for demanding offshore and coastal infrastructure programmes.",
      image: "/images/raec.webp",
      location: "Offshore and coastal construction sites",
      scope: "Marine construction, installation support, site preparation and offshore infrastructure works.",
    },
    {
      category: "INDUSTRIAL SERVICES",
      title: "Industrial Facility Works",
      description: "Reliable industrial services that support maintenance, construction and facility performance.",
      image: "/images/services1.webp",
      location: "Industrial and energy facilities",
      scope: "Industrial maintenance, construction support, repairs and facility performance improvement.",
    },
    {
      category: "ENERGY PARTNERSHIPS",
      title: "Energy Sector Collaboration",
      description: "Collaborative delivery for energy clients, partners and stakeholders across the project lifecycle.",
      image: "/images/total.webp",
      location: "Energy sector project environments",
      scope: "Client collaboration, project coordination, technical support and lifecycle delivery.",
    },
    {
      category: "CLIENT DELIVERY",
      title: "Project Delivery for Global Partners",
      description: "Performance-driven delivery built around trust, coordination and measurable results.",
      image: "/images/shell.webp",
      location: "Client project locations",
      scope: "Project management, stakeholder coordination, delivery assurance and operational support.",
    },
    {
      category: "OFFSHORE OPERATIONS",
      title: "Offshore Platform Support",
      description: "Integrated offshore support for installation, maintenance and operational continuity.",
      image: "/images/chevron.webp",
      location: "Offshore platforms and production assets",
      scope: "Platform support, installation assistance, maintenance coordination and operations continuity.",
    },
    {
      category: "PEOPLE AND CAPABILITY",
      title: "Building Technical Capability",
      description: "Developing people and technical capability to support safer, stronger project outcomes.",
      image: "/images/graduate.webp",
      location: "Strides training and project environments",
      scope: "Technical development, workforce training and capability-building initiatives.",
    },
    {
      category: "FIELD OPERATIONS",
      title: "On-Site Delivery and Coordination",
      description: "Experienced site teams coordinating complex work with care, clarity and accountability.",
      image: "/images/ediworo.webp",
      location: "Onshore and offshore project sites",
      scope: "Site coordination, field supervision, work planning and execution management.",
    },
    {
      category: "MARINE SUPPORT",
      title: "Marine Support and Coastal Services",
      description: "Coastal support services that strengthen marine access, field coordination and project readiness.",
      image: "/images/marine (1).webp",
      location: "Coastal and offshore project locations",
      scope: "Marine logistics, coastal support, vessel coordination and operational readiness services.",
    },
  ];

  const visibleProjects = featuredOnly
    ? projects.slice(0, 4)
    : showAll
      ? projects.slice(0, 21)
      : projects.slice(0, 6);

  return (
    <>
      {!featuredOnly && (
        <section className="projects-page-hero">
          <img
            className="projects-page-hero-image"
            src="/images/cluster 5a.webp"
            alt="Offshore crews working at Cluster 5A"
          />
          <div className="projects-page-hero-overlay" />
          <div className="projects-container projects-page-hero-content">
            <span className="projects-eyebrow">PROJECTS</span>
            <h1>Project delivery in the field.</h1>
            <p>
              From energy to maritime operations, we deliver solutions that
              create measurable value for our clients and partners.
            </p>
          </div>
        </section>
      )}
    <section className={`projects${featuredOnly ? " projects-featured-only" : ""}`} id="projects">

      {/* ==================================================
          PROJECTS CONTAINER
          ================================================== */}

      <div className="projects-container">

        {/* ==================================================
            SECTION HEADER
            ================================================== */}

        <div className="projects-header">

          <div className="projects-heading">

            <span className="projects-eyebrow">
              FEATURED PROJECTS
            </span>

            <h2>
              Delivering
              <br />
              Where It Matters.
            </h2>

          </div>


          <div className="projects-header-right">

            <p>
              From energy to maritime operations, we deliver
              solutions that create measurable value for our
              clients and partners.
            </p>

          </div>

        </div>


        {/* ==================================================
            PROJECT LIST
            ================================================== */}

        <div className="projects-list">

          {visibleProjects.map((project) => (

            <article
              className="project-card"
              key={project.title}
            >

              <div className="project-image-wrapper">
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-image"
                />

                <div className="project-image-overlay"></div>

              </div>

              <div className="project-content">
                <span className="project-category">
                  {project.category}
                </span>

                <h3>
                  {project.title}
                </h3>

                <p>
                  {project.description}
                </p>

                {project.location && (
                  <dl className="project-details">
                    <div>
                      <dt>Location</dt>
                      <dd>{project.location}</dd>
                    </div>

                    {!featuredOnly && (
                      <div>
                        <dt>Scope</dt>
                        <dd>{project.scope}</dd>
                      </div>
                    )}
                  </dl>
                )}
              </div>
            </article>
          ))}

        </div>


        {/* ==================================================
            PROJECT FOOTER
            ================================================== */}

        {!featuredOnly && <div className="projects-footer">

          <span>
            Explore our portfolio
          </span>

          <button
            type="button"
            className="projects-button"
            onClick={() => setShowAll((current) => !current)}
          >

            <span>
              {showAll ? "Show Fewer Projects" : "View More Projects"}
            </span>

            <span>
              →
            </span>

          </button>

        </div>}

      </div>

      </section>
    </>
  );
}

export default Projects;